import { render, staticRenderFns } from "./CheckoutItem.vue?vue&type=template&id=0d24f459&scoped=true&"
import script from "./CheckoutItem.vue?vue&type=script&lang=js&"
export * from "./CheckoutItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutItem.vue?vue&type=style&index=0&id=0d24f459&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d24f459",
  null
  
)

export default component.exports